import { render, staticRenderFns } from "./AssignPromoPlan.vue?vue&type=template&id=38792b06&scoped=true&"
import script from "./AssignPromoPlan.vue?vue&type=script&lang=js&"
export * from "./AssignPromoPlan.vue?vue&type=script&lang=js&"
import style0 from "./AssignPromoPlan.vue?vue&type=style&index=0&id=38792b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38792b06",
  null
  
)

export default component.exports